/* @flow */
type SearchBannerAddActionType = 'SEARCH_BANNER/ADD';
export type ActionType = SearchBannerAddActionType;

type SearchBannerAddAction = {
    type: SearchBannerAddActionType,
    payload: {
        location: string
    }
};

export type Action = SearchBannerAddAction;

const ACTION_CREATORS = {
    searchBannerAddLocation(location: string): Action {
        return {
            type: 'SEARCH_BANNER/ADD',
            payload: {
                location
            }
        };
    }
};

export default {
    ...ACTION_CREATORS
};
